import C from "@/admin/AdminLayout.module.css";

import { cn } from "@/utils/classNames.ts";
import { useTitle } from "@/utils/react/useTitle.ts";
import type { ReactNode } from "react";

export function AdminTitle({ title, children }: { title: string; children?: ReactNode }) {
    useTitle(title);

    return (
        <div className={cn(C.Title, "flex items-center justify-between p-2 gap-1")}>
            <h1 className="flex-shrink-0 font-size-default text-ellipsis whitespace-nowrap font-bold">{title}</h1>
            {children}
        </div>
    );
}
